import React, { useState } from 'react';
import { connect } from "react-redux";
import { updateProfile, uploadProfilePic} from "../../../Redux/actions/user";
import empty_profile from "../../../Assets/emptyimage.png";
import keycloak from '../../../keycloak';
import phoneNumbers from "../../../Utilities/phoneNumbers";
import { addNotification } from "../../../Utilities/notifications"; 
import "./index.css";
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

function ProfileSettings(props){
    let { user } = props;
    
    let error = {
      given_name:"",
      family_name:"",
      contactNumber:""
    }

    document.title = "Your Profile Settings | E-Manager Console | Techforce.ai";

    let   [errors ,setErrors] = useState(error)
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({...user});
    const [submitBtnFlag, setSubmitBtnFlag ] = useState(true)

    const handleInputChange = e => {
      const { name, value } = e.target;
      
      switch(name){        
        case 'given_name':
          errors.given_name = value.length === 0 ? "First name should not be empty" : ""
          break;
        case 'family_name':
          errors.family_name = value.length === 0 ? "Last name should not be empty" : ""
          break;
        default:
      }
      
      setErrors(errors)            
      setValues({ ...values, [name]: value });
      setSubmitBtnFlag(false);
    };

    const validation = (errors)=>{              
      let valid = true;
      Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
      );        
      return valid;
    }

    const uploadPic = async(e) =>{
      let file = e.target.files[0]
      let testArray = 'profilePic' in values;
      if(!testArray){
        values["profilePic"] = ""
      }      
      if(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/jfif'){                
      let data = await uploadProfilePic(file)      
      setValues({ ...values, profilePic: data.URL });
      }
      setSubmitBtnFlag(false);

    }

    const handleSubmit = async (e) => {            
        e.preventDefault();        
        if(validation(errors)){          
          setLoading(true); 
          let data = await updateProfile({...values}, user);          
          if(data.status === 204){
            addNotification({
              title: "Techforce.ai",
              message: "Profile has been updated Successfully",
              type: "success"
            });
            keycloak.login();
          }
          setLoading(false);
        }
    }

    const onPhoneNumberChange = (phn,obj)=>{       
      let result = phoneNumbers.filter(i => i.countryCode === obj.countryCode) ;            
      let format=phn.replace(/[^\w\s]/gi, '')
      let phnNumber=format.replace(/ /g,'')      
      
      errors.contactNumber = phnNumber.length.toString() !== result[0].length? "Please enter valid contactNumber" :""
      setErrors(errors)
      setValues({ ...values, contactNumber: phn });
      setSubmitBtnFlag(false);
    }
    
    return (
      <div className="profile-container">
        <div className="sub-head">
          <h2 className="heading">Profile Settings</h2>
        </div>
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="emailAddress">Email address</label>
              <input
                type="email"
                name="email"
                value={values.email}
                disabled
                className="form-control"
                id="emailAddress"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                name="given_name"
                onChange={handleInputChange}
                value={values.given_name ? values.given_name : ""}
                className="form-control"
                id="firstName"
                placeholder="First Name"
              />
               {errors.given_name.length > 0 && 
              <span className='error'>{errors.given_name}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                name="family_name"
                onChange={handleInputChange}
                value={values.family_name ? values.family_name : ""}
                className="form-control"
                id="lastName"
                placeholder="Last Name"
              />
               {errors.family_name.length > 0 && 
              <span className='error'>{errors.family_name}</span>}
            </div>
            <div className="form-group ">
              <label htmlFor="contactNumber">Contact Number</label>
              <ReactPhoneInput
                inputExtraProps={{
                  name: "phone",
                  required: true,
                  autoFocus: true
                }}
                country={"in"}
                value={values.contactNumber ? values.contactNumber : ""}
                onChange={onPhoneNumberChange}
              />
               {errors.contactNumber.length > 0 && 
                  <span className='error'>{errors.contactNumber}</span>}
            </div>
            <div className="text-center" style={{marginTop:"20px"}}>
              <button
                disabled={submitBtnFlag}
                onClick={handleSubmit}
                className="btn mr-3"
                style={{width : "150px"}}
              >
                {loading ? "loading .." : "Update Profile"}
              </button>
            </div>
          </form>
          <div className="rect-img text-center">
              <img
                src={values.profilePic ? values.profilePic : empty_profile}
                className="rounded mx-auto d-block"
                alt="..." 
              />
              <div className="profile"><input type="file" name="profilePic" accept="image/*"
               onChange={uploadPic}/></div>
          </div>
        </div>
      </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(ProfileSettings);